(function() {
  var mq = window.matchMedia('(max-width: 749px)');
  
  function initAccordion() {
    var blocks = document.querySelectorAll('.footer .footer__block .v-stack.gap-4');
    blocks.forEach(function(block) {
      var heading = block.querySelector('.h6');
      var list = block.querySelector('ul');
      if (!heading || !list) return;
      
      if (mq.matches) {
        heading.classList.add('footer-accordion-toggle');
        list.classList.add('footer-accordion-content');
        list.style.display = 'none';
        
        heading.onclick = function() {
          var isOpen = heading.classList.contains('is-open');
          heading.classList.toggle('is-open');
          list.style.display = isOpen ? 'none' : 'block';
        };
      } else {
        heading.classList.remove('footer-accordion-toggle', 'is-open');
        list.classList.remove('footer-accordion-content');
        list.style.display = '';
        heading.onclick = null;
      }
    });
  }
  
  initAccordion();
  mq.addEventListener('change', initAccordion);
})();